import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/greenwood-village-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Greenwood Village", "greenwood-village"),
  component: () => (
    <CityDigitalMarketingPage
      city="Greenwood Village"
      slug="greenwood-village"
      intro="Greenwood Village is the corporate heart of metro Denver — DTC offices, law firms, finance, and the highest-income residential ZIPs in Colorado. We help Greenwood Village businesses dominate Google, the Map Pack, and AI search from our Colorado Springs HQ."
      whyUs={[
        "DTC corridor specialists — we know the Denver Tech Center, Belleview corridor, and Cherry Hills-adjacent neighborhoods",
        "Hyper-local SEO and web design for professional services (law, finance, medical, executive coaching)",
        "Owner-led strategy from Chris — not a Denver agency where you're account #173",
      ]}
      nearby={[
        { name: "Lone Tree", to: "/lone-tree-digital-marketing" },
        { name: "Centennial", to: "/centennial-seo" },
        { name: "Highlands Ranch", to: "/highlands-ranch-digital-marketing" },
        { name: "Denver", to: "/denver-digital-marketing" },
        { name: "Aurora", to: "/aurora-digital-marketing" },
      ]}
      testimonial={{
        quote:
          "Chris understood our DTC clientele better than any of the local agencies we interviewed. The site converts and the SEO compounds.",
        role: "Professional Services Owner",
        city: "Greenwood Village",
      }}
      industryLinks={industryLinksFor("Greenwood Village")}
    />
  ),
});
